import { formatDayRange } from "@/lib/equipment/availability";
import { lineLabel, type DraftLine, type DraftWarning } from "@/lib/equipment/booking-draft";
import { TONE_PILL } from "@/lib/widget-status";
import { cn } from "@/lib/utils";
import type { DBEquipmentItem } from "@/lib/db-types";

interface BookingConflictNoticeProps {
  /** Linjene i dialogen som er dobbeltbooket. */
  lines: DraftLine[];
  items: Map<string, DBEquipmentItem>;
  warnings: Map<string, DraftWarning>;
}

/** «Dzofilm Pictor Zoom er også booket 29.10: 619 Apriil (1 stk, 29.–31.10, Christer). Du kan booke likevel.» */
export function BookingConflictNotice({ lines, items, warnings }: BookingConflictNoticeProps) {
  if (lines.length === 0) return null;
  return (
    <div role="alert" className={cn("rounded-md px-4 py-3 text-sm space-y-2", TONE_PILL.near)}>
      {lines.map((line) => (
        <div key={line.key}>
          <p className="font-semibold">
            ⚠ {items.get(line.item_id)?.name ?? "Utstyret"} er også booket {formatDayRange(line.date_from, line.date_to)}
          </p>
          <ul>
            {warnings.get(line.key)?.conflicts.map((o) => (
              <li key={o.id}>
                {lineLabel(o)} ({o.quantity} stk, {formatDayRange(o.date_from, o.date_to)}
                {o.responsible_name ? `, ${o.responsible_name}` : ""})
              </li>
            ))}
          </ul>
        </div>
      ))}
      <p>Du kan booke likevel. Begge bookingene merkes med ⚠ til det er løst.</p>
    </div>
  );
}
